<mat-nav-list>
  @for (user of sortedUsers(); track user.id) {
    <mat-list-item (click)="onSelectUser(user)" [disableRipple]="true" [lines]="1" class="hoverable fs-12">
      <span matListItemTitle>{{ user.firstname }} {{ user.lastname }}</span>
    </mat-list-item>
  }
</mat-nav-list>
